import {
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Popover,
  Switch,
  Typography,
} from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";
import React, { MouseEvent } from "react";
import SearchBar from "src/shared/components/SearchBar";
import { filterSportsBySeason } from "../../utils";
import { SportFilter } from "./components/sport-filter/SportFilter";
import {
  ADVANCED_FILTERS_BUTTON_LABEL,
  ONLY_SHOW_INACTIVE_FORM_LABEL,
  SEARCH_BAR_LABEL,
  SHOW_INACTIVE_FORM_LABEL,
  TOGGLE_COACHES,
} from "./constants";
import { IAdvancedFiltersProps } from "./types";
import { useStyles } from "./styles";

export const AdvancedFilters = ({
  filter,
  search,
  sports,
  seasons,
  seasonName,
  handleFilterChange,
  handleSearchChange,
  showInactive,
  onlyShowInactive,
  toggleShowInactive,
  toggleOnlyShowInactive,
  isMeadSeason,
  coachsportId,
  schoolData
}: IAdvancedFiltersProps) => {
  const filteredSports = filterSportsBySeason({ seasonName, seasons, sports });
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    // @ts-ignore
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <Button
        aria-describedby={id}
        variant="contained"
        color="primary"
        onClick={handleClick}
      >
        {ADVANCED_FILTERS_BUTTON_LABEL}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
      >
        <Box display="flex" padding="0.5rem 1rem" gridGap="1rem">
          <SportFilter
            filter={filter}
            schoolData={schoolData}
            filteredSports={filteredSports}
            handleFilterChange={handleFilterChange}
            isMeadSeason= {isMeadSeason}
            coachsportId= {coachsportId}
            sports={sports}
          />
          <SearchBar
            Adornment={AccountCircle}
            label={schoolData?.isAdSurvey ? "Search AD" : SEARCH_BAR_LABEL}
            search={search}
            onChange={handleSearchChange}
          />
          <FormGroup row={true}>
            <Box display="flex" flexDirection="column">
              <InputLabel className={classes.inputLabel}>
                {
                schoolData?.isAdSurvey ? "Show / Hide AD's" : TOGGLE_COACHES}
              </InputLabel>
              <Box>
                <FormControlLabel
                  control={
                    <Switch
                      checked={showInactive}
                      value="check"
                      onChange={toggleShowInactive}
                    />
                  }
                  label={
                    <Typography variant="body2">
                      {SHOW_INACTIVE_FORM_LABEL}
                    </Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={onlyShowInactive}
                      value="check"
                      onChange={toggleOnlyShowInactive}
                    />
                  }
                  label={
                    <Typography variant="body2">
                      {ONLY_SHOW_INACTIVE_FORM_LABEL}
                    </Typography>
                  }
                />
              </Box>
            </Box>
          </FormGroup>
        </Box>
      </Popover>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/features/director/pages/dashboard/components/advanced-filters/AdvancedFilters.tsx